import { render, staticRenderFns } from "./notice-component.vue?vue&type=template&id=5064ad70&scoped=true&"
import script from "./notice-component.vue?vue&type=script&lang=js&"
export * from "./notice-component.vue?vue&type=script&lang=js&"
import style0 from "./notice-component.vue?vue&type=style&index=0&id=5064ad70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5064ad70",
  null
  
)

export default component.exports